import Main from './Main.container.js';

export default Main;
